import { render } from "./index.vue?vue&type=template&id=bdc71a0a&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=bdc71a0a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdc71a0a"]])

export default __exports__